module.exports = __webpack_public_path__ + "img/20200330144111359.dd60c47f.png";